export default __webpack_public_path__ + "static/media/BV.51877f22.svg";